import { makeAutoObservable, runInAction } from 'mobx'
import { logger } from 'shared/lib'
import { TableStore } from 'shared/ui/TableNew'
import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase.ts'
import {
  type IResponseFrontChannel,
  type Integration,
  IntegrationsApi,
} from 'entities/Integrations'
import { type IEntitiesStore } from 'entities/EntitiesExport'

export class FrontChannelRow extends RowBase<IResponseFrontChannel & { id: string }> {
  constructor(origin: IResponseFrontChannel) {
    super({
      ...origin,
      id: `${origin.front_inbox?.id}_${origin.salesmsg_inbox?.id}_${origin.number?.id}`,
    })
    makeObservableRowBase(this)
  }
}

export class IntegrationFrontSettingsStore {
  readonly tableStore: TableStore<FrontChannelRow>
  constructor(private _integration: Integration, private _entities: IEntitiesStore) {
    this.tableStore = new TableStore({
      key: 'FrontMappingsTable',
    })
    makeAutoObservable(this)
  }

  private _loading = false
  init = async () => {
    runInAction(() => {
      this._loading = true
    })
    await this.getChannels()

    runInAction(() => {
      this._loading = false
    })
  }

  private _channelsRows: FrontChannelRow[] = []
  get channelsRows() {
    return this._channelsRows
  }

  get loading() {
    return this._loading
  }

  getChannels = async () => {
    try {
      const { data } = await IntegrationsApi.getFrontIntegrationChannels(this._integration.key)

      runInAction(() => {
        this._channelsRows = data.channels.map((item) => new FrontChannelRow(item))
      })
    } catch (e) {
      runInAction(() => {
        this._channelsRows = []
      })
      logger.error(e)
    }
  }
}
